import styled from "@emotion/styled";

const Button = styled.button`
  font-weight: 500;
  border-radius: 6px;
  border: none;
  background-color: teal;
`;

export { Button };
